import React from 'react';

function ChamadoDescriptionField({ value, onChange, id = 'chamado-descricao' }) {
    return (
        <div className="chamado-create-field chamado-create-description field-full">
            <label htmlFor={id}>Descrição do chamado</label>
            <textarea
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Descreva o problema ou solicitação..."
                rows={4}
            />
        </div>
    );
}

export default ChamadoDescriptionField;
